import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';
import { TaskGroup } from '../models/taskGroup.model';

@Injectable({
    providedIn: 'root'
})
export class TaskGroupService extends GridService<TaskGroup> {

    constructor(http: HttpClient) {
        super('TaskGroup', http);
    }
}
